<template>
  <div class="print-break-after">
    <!-- NOTE -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Notes', 'Note') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          :class="['input-elem com-anm22-app-textarea', mode === 'view' ? 'stamp' : '']"
          style="height:100px;width:100%;max-width:unset;"
          v-model.lazy="formData.notes"
        ></textarea>
      </div>
    </div>
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Last edit', 'Ultima modifica') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ lastEditDate + ' ' + lastEditUser }}</div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div v-if="mode === 'edit'" class="wg-row">
      <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="saveForm" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      formData: {}
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    }
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.finishing = this.formData;
      docs.finishing.lastUser = this.user.idWorldUser;
      docs.finishing.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    }
  },
  created() {
    this.formData = { ...this.docs.finishing };
    if(this.formData.notes && Array.isArray(this.formData.notes)) {
      if(this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[this.formData.notes.length - 1].note;
      } else {
        this.formData.notes = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-row {
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}
.input-elem {
  width: 200px;
  margin-bottom: 10px;
}
.stamp {
  height: 450px !important;
}
</style>
